import { takeEvery, all, fork, call, put } from "redux-saga/effects";

// Crypto Redux States
import {
  UPDATE_SPECIAL_DATES,
  GET_SPECIAL_DATES,
  ADD_SPECIAL_DATES,
  DELETE_SPECIAL_DATES,
  GET_EXPORT_SPECIAL_DATES
} from "./actionTypes";

import { specialDatesApiSuccess, specialDatesApiFail, getExportSpecialDateSuccess, getExportSpecialDateFail } from "./actions";

//Include Both Helper File with needed methods
import {
  getSpecialDates as getSpecialDatesApi,
  addSpecialDates as addSpecialDatesApi,
  updateSpecialDate as updateSpecialDateApi,
  deleteSpecialDate as deleteSpecialDateApi,
  getExportSpecialDate
} from "helpers/backend_helper";

function* getSpecialDates({ payload: filter }) {
  try {
    const response = yield call(getSpecialDatesApi, filter);
    yield put(specialDatesApiSuccess(GET_SPECIAL_DATES, response.data));
  } catch (error) {
    yield put(specialDatesApiFail(GET_SPECIAL_DATES, error));
  }
}

function* addSpecialDates({ payload: data }) {
  try {
    const response = yield call(addSpecialDatesApi, data);
    if (response?.success) {
      yield put(specialDatesApiSuccess(ADD_SPECIAL_DATES, { ...response }));
    } else {
      yield put(specialDatesApiFail(ADD_SPECIAL_DATES, { ...response }));
    }
  } catch (error) {
    yield put(specialDatesApiFail(ADD_SPECIAL_DATES, error));
  }
}

function* updateSpecialDate({ payload: { specialDateId, data } }) {
  try {
    const response = yield call(updateSpecialDateApi, specialDateId, data);
    yield put(specialDatesApiSuccess(UPDATE_SPECIAL_DATES, { ...response }));
  } catch (error) {
    yield put(specialDatesApiFail(UPDATE_SPECIAL_DATES, error));
  }
}

function* deleteSpecialDates({ payload: specialDateId }) {
  try {
    yield call(deleteSpecialDateApi, specialDateId);
    yield put(specialDatesApiSuccess(DELETE_SPECIAL_DATES, specialDateId));
  } catch (error) {
    yield put(specialDatesApiFail(DELETE_SPECIAL_DATES, error));
  }
}


function* fetchExportSpecialDate({ payload }) {
  try {
    const response = yield call(getExportSpecialDate, payload);
    yield put(getExportSpecialDateSuccess(response));
  } catch (error) {
    yield put(getExportSpecialDateFail(error));
  }
}

function* watchUpdateSpecialDate() {
  yield takeEvery(UPDATE_SPECIAL_DATES, updateSpecialDate);
}

function* watchGetSpecialDates() {
  yield takeEvery(GET_SPECIAL_DATES, getSpecialDates);
}

function* watchAddSpecialDates() {
  yield takeEvery(ADD_SPECIAL_DATES, addSpecialDates);
}

function* watchDeleteSpecialDates() {
  yield takeEvery(DELETE_SPECIAL_DATES, deleteSpecialDates);
}

function* watchFetchExportSpecialDate() {
  yield takeEvery(GET_EXPORT_SPECIAL_DATES, fetchExportSpecialDate);
}

function* settingsSaga() {
  yield all([
    fork(watchAddSpecialDates),
    fork(watchGetSpecialDates),
    fork(watchDeleteSpecialDates),
    fork(watchUpdateSpecialDate),
    fork(watchFetchExportSpecialDate),
  ]);
}

export default settingsSaga;
